import React, { FC, MouseEvent, useCallback } from 'react';
import Text, { TextSize } from '@move-ui/text';
import Clickable from '@move-ui/clickable';
import { MaskedLink } from '@move-web-essentials-utils/masked-link';
import cx from 'classnames';
import styles from './FooterLinks.css';
import { FooterLinkItem, NavigationClickHandler } from '../../types';

type Props = Omit<FooterLinkItem, 'url'> & {
  url: string;
  onClick?: NavigationClickHandler;
  className?: string;
  index?: number;
};

const FooterLink: FC<Props> = ({
  name,
  label,
  id,
  type,
  url,
  alt,
  crawlable = false,
  testId,
  onClick,
  className,
  index
}) => {
  const handleClick = useCallback(
    (event: MouseEvent) => onClick?.(name, { type, url }, event),
    [name, type, url, onClick]
  );

  const text = (
    <Text size={TextSize.XS} color="neutral-200">
      {label}
    </Text>
  );

  if (crawlable) {
    return (
      <a
        href={url}
        title={alt}
        id={id}
        className={cx(styles.columnItem, className)}
        data-testid={`footer-link-${testId || index}`}
        onClick={handleClick}
      >
        {text}
      </a>
    );
  }

  return (
    <MaskedLink
      url={url}
      id={id}
      data-testid={`footer-link-${testId || index}`}
    >
      <Clickable
        role="link"
        onClick={handleClick}
        className={cx(styles.columnItem, className)}
      >
        {text}
      </Clickable>
    </MaskedLink>
  );
};

export default FooterLink;
